module.exports = __webpack_public_path__ + "static/media/Equifax.c166f62f.png";